import { DeviceInfo } from 'ngx-device-detector';

export interface UserInfoDto {
	customerTitle: string;
	phoneNumber?: string;
	email?: string;
	nationalId?: string;
	customerIsin?: string;
	firstName?: string;
	lastName?: string;
	bourseCode?: string;
	userFullName?: string;
	loginDate?: Date;
}

export interface UserBourseCodeDto {
	bourseCode?: string;
}

export interface DeviceInfoDto {
	deviceType: DeviceTypeEnum;
}

export interface AccountActivityItemDto {
	id: string;
	createDateTime: Date;
	expiryDate: Date;
	logoutDate: Date;
	deviceType: DeviceTypeEnum;
	ip: string;
	userAgent: string;
	isExpired?: boolean;
	deviceInfo?: DeviceInfo;
	isCurrentSession: boolean;
}
export interface AccountUserInfo {
	name: string;
	family: string;
	bourseCode: string;
	mobile: string;
	email: string;
}

export enum DeviceTypeEnum {
	Unknown = -1,
	Mobile = 0,
	Desktop = 1
}
